<template>
	<span class="animated-number">{{ animatedNumber }}</span>
</template>

<script>
import { TweenLite } from 'gsap';

export default {
	props: {
		number: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			tweenedNumber: 0,
		};
	},
	computed: {
		animatedNumber() {
			return this.tweenedNumber.toFixed(0);
		},
	},
	watch: {
		number(newValue) {
			TweenLite.to(this.$data, 0.5, {
				tweenedNumber: newValue,
				onComplete: () => {
					this.$emit("tweenComplete");
				},
			});
		},
	},
	created() {
		this.tweenedNumber = this.number;
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/abstract/AnimatedNumber.vue